import TextInput from '~/components/TextInput';
import React from 'react';

const QuantityLabelSetting = ({ settings, setSettings }) => {
    return (
        <>
            {!settings?.hideQuantity && (
                <div className="mt-4">
                    <TextInput
                        value={settings?.quantityLabel || ''}
                        onChange={value =>
                            setSettings({
                                ...settings,
                                quantityLabel: value,
                            })
                        }
                        label="Quantity Label"
                        placeholder="Quantity"
                    />
                    <div className="text-gray-500 text-sm ml-4 mt-1">
                        This is the label for the quantity when booking multiple
                        spots, ex., "Number of Attendees"
                    </div>
                </div>
            )}
        </>
    );
};

export default QuantityLabelSetting;
